import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "d-flex" };
const _hoisted_2 = {
    class: "me-4",
    style: { "min-width": "2rem" }
};
const _hoisted_3 = { class: "mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_radio_button_form = _resolveComponent("radio-button-form");
    const _component_el_radio = _resolveComponent("el-radio");
    const _component_el_table = _resolveComponent("el-table");
    return (_openBlock(), _createBlock(_component_el_table, {
        data: (_a = _ctx.competencyUnit.statements) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerTypeId === _ctx.answerTypeId),
        "scrollbar-always-on": true,
        "default-expand-all": ""
    }, {
        default: _withCtx(() => {
            var _a;
            return [
                _createVNode(_component_el_table_column, {
                    label: "Pertanyaan",
                    width: "auto",
                    "min-width": "400"
                }, {
                    default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(`${scope.$index + 1}`), 1 /* TEXT */),
                            _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_3, _toDisplayString(scope.row.description), 1 /* TEXT */)
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_a = _ctx.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerType.id === _ctx.answerTypeId)) || [], (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.answerField.type === 'radio')
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: item.label,
                                align: "center"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, optionIndex) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: optionIndex,
                                            label: option.label,
                                            align: "center",
                                            width: "130"
                                        }, {
                                            default: _withCtx((scope) => [
                                                (_ctx.isAssessment)
                                                    ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                        key: 0,
                                                        modelValue: _ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementAnswerFields].value,
                                                        "onUpdate:modelValue": ($event) => ((_ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementAnswerFields].value) = $event),
                                                        options: [{ label: null, value: option.value }],
                                                        borderless: "",
                                                        disabled: _ctx.disabled,
                                                        center: "",
                                                        rules: [_ctx.validationRequired()],
                                                        prop: `fields.${_ctx.order}.statementFields.${_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementFields}.statementAnswerFields.${_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementAnswerFields}.value`
                                                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "disabled", "rules", "prop"]))
                                                    : (_openBlock(), _createBlock(_component_el_radio, {
                                                        key: 1,
                                                        label: option.value,
                                                        disabled: _ctx.disabled
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(null))
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "disabled"]))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ];
        }),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"]));
}
